
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ShipPage from './pages/ShipPage';
import DrivePage from './pages/DrivePage';
import HomePage from './pages/HomePage';
import OrderPage from './pages/OrderPage';
import { ConfigsContextProvider } from './components/ConfigsContext';
import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './data/firebase';
import CancelledPage from './pages/CancelledPage';
import SuccessPage from './pages/SuccessPage';
import Header from './components/Header';

function App() 
{
  const [user, setUser] = useState(null);  

  useEffect(() =>
  {
    const unsubscribe = onAuthStateChanged(auth, (u) => 
      {
        setUser(u);
      });
    return () => unsubscribe();
  }, []);

  return (

    <ConfigsContextProvider>
    <Router>

       <Header user={user}/>

      <Routes>
        
        <Route path='/' element={<HomePage/>}/>

        <Route path ='/ship' element={<ShipPage user={user}/>}/>
        <Route path ='/drive' element={<DrivePage user={user}/>}/>
        <Route path ='/order' element={<OrderPage user={user}/>}/>

        <Route path = '/cancelled' element={<CancelledPage user={user}/>}/>
        <Route path = '/success' element={<SuccessPage user={user}/>}/>

        <Route path = '*' element={<div>Loading...</div>}/>
      
      </Routes>
    </Router>
    </ConfigsContextProvider>

  );
}

export default App;